import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 0 1rem 0;

  .subHeader {
    display: flex;
    align-items: flex-end;

    h1 {
      color: ${({ theme }) => theme.colors.tertiary_500};
      font-size: 22px;
      margin: 0;
      width: 100%;
      font-weight: medium;
      margin-left: 0.5rem;
    }

    svg {
      width: 1.8rem;
      height: 1.8rem;
      fill: ${({ theme }) => theme.colors.tertiary_500};
      stroke: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .close-div {
    padding: 0;
    height: 20px;

    button {
      color: #fff;
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  width: 100%;
  margin: 0 auto 1rem;
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
